"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalTitle = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../utils/constants");
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _Title = require("../Title/Title");
var _Modal = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal.css") : void 0);
const _excluded = ["children", "className", "headingLevel"];
const CSS_BLOCK = 'sapcnqr-modal';
const ModalTitle = exports.ModalTitle = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      children,
      className,
      headingLevel = 2
    } = props,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  const classnames = _bind.default.bind(_Modal.default);
  const titleClasses = classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__title`, className);
  return /*#__PURE__*/_react.default.createElement(_Title.Title, (0, _extends2.default)({}, otherProps, {
    className: titleClasses,
    headingLevel: headingLevel,
    headingStyle: 2,
    ref: ref
  }), children);
});
ModalTitle.displayName = 'Modal.Title';
ModalTitle.propTypes = {
  /** Content of the modal title. */
  children: _propTypes.default.node,
  /** Custom classes to add to the title's `<h#>` tag. */
  className: _propTypes.default.string,
  /** Sets the semantic heading level for the modal title: `<h2>`.
   * Allowable values are **2** through **6**.
   * (`<h1>` headings are managed by the framework itself.) */
  headingLevel: _CustomPropTypes.default.range(2, 6)
};
var _default = exports.default = ModalTitle;